import {
    Grid,
} from "@material-ui/core";
import { Button, DatePicker, Form, Input, message, Modal, Select, Spin, Switch, TimePicker } from "antd";
import moment from "moment-timezone";
import { object } from "prop-types";
import React, { useEffect, useState } from 'react'
import DynamicFormFieldsAntd from "../../../Components/InputComponents/DynamicFormFIeldsAntd";
import LeftControl from '../../../Components/LeftControl'
import PageHeader from '../../../Components/PageHeader'
import { causeCodeOptions, IncidentDropdowns, tgsLocation, TODIncident, visibiltyIncident } from "../../../Components/TableComponents/constants";
import { checkDate, checkRes, LabelIncident, ValidateDate } from "../../../helpers/textValidation";
import services from "../../../Services";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import TextArea from "antd/lib/input/TextArea";
import { Cancel } from "@material-ui/icons";
import { useHistory, useParams } from "react-router-dom";
import { utility } from "../../../helpers/loader";
import { setPageLoader } from "../../../redux/features/utils.slice";
import AttachFilesIncident from "../../../Components/AttachmentFiles/AttachFIlesIncident";
import GoBack from "../../../Components/GoBackButton/GoBack";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";

const inputStyle = {
    padding: "10px",
    borderRadius: "8px",
}
const {
    employee,
    Storage,
    hr
} = services;

const EnterIncidentAntd = () => {

    const history = useHistory()
    const [form] = Form.useForm()
    const [formFinalize] = Form.useForm()
    const [empty, setEmpty] = useState(true)
    const [departments, setDeprtments] = useState([])
    const [locations, setLocations] = useState([])
    const [employees, setEmployees] = useState([])
    const [classification, setClassification] = useState([])
    const [subDepartment, setSubDepartments] = useState([])
    const [types, setTypes] = useState([])
    const [RailIncident, setRailIncident] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [additionalFiles, setAdditionalFiles] = useState([]);
    const { id } = useParams()
    const [uploadedFiles, setUploadedFiles] = useState([])
    const [isFinalized, setisFinalized] = useState(false)
    const [isReopenModalOpen, setIsReopenModalOpen] = useState(false);
    const [location, setlocation] = useState()
    const [LocLoading, setLocLoading] = useState(false)
    const [enteredDetails, setenteredDetails] = useState()


    const tabState = history?.location

    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const fetchData = async () => {

        const promises = [
            employee.get_site_listing(),
            hr.department(),
            employee.get_employee_listing_not_Terminated(),
            hr.getIncidentTypes(),
        ]
        const [res1, res2, res3, res4] = await Promise.all(promises)
        setDeprtments(res2?.data)
        setLocations(res1?.data)
        const employees = res3?.data?.map((x) => ({ id: x?.id, title: `${x?.firstName} ${x?.lastName}`, hiredDate: x?.hireDate }))
        setEmployees(prev => { return prev = employees })
        setTypes(res4.data?.map(x => { return { id: x?.id, title: x?.Type } }))
        return { departments: res2?.data, employees, locations: res1?.data }
    }

    const fetchSubDepartments = async (value) => {
        form.setFieldsValue({
            SubDepartmentId: undefined
        })
        let response = await hr.subDepartment({ id: value })

        if (response.httpStatus === 200) setSubDepartments(response?.data)
    }

    const fetchClassifications = async (value) => {
        form.setFieldsValue({
            ClassificationId: undefined
        })
        let response = await hr?.getClassifications(value)
        if (response.httpStatus === 200) setClassification(response?.data?.map(x => { return { id: x?.classID, title: x?.Class } }))
    }

    const fetchIncidentByID = async (id) => {
        let res = await hr.incidentFieldsByID(id)
        let data = res?.data
        setUploadedFiles(res?.files)
        setisFinalized(res?.data?.isFinalized)
        let { employees: employeeList } = await fetchData()
        if (data?.SubDepartment?.Department?.id) await fetchSubDepartments(data?.SubDepartment?.Department?.id)
        if (data?.IncidentTypeId) await fetchClassifications(data?.IncidentTypeId)
        if (data?.RailIncident) setRailIncident(data?.RailIncident)
        setEmpty(false)
        utility?.dispatch(setPageLoader({ pageName: "main", flag: true }))
        setTimeout(() => {
            // setenteredDetails({ by: data?.EnteredBy?.firstName + data?.EnteredBy?.lastName, at: data?.createdAt })
            form.setFieldsValue({
                IncidentDate: checkDate(data?.IncidentDate, "date"),
                IncidentTime: checkDate(data?.IncidentTime, "time"),
                LocationId: checkRes(data?.LocationId),
                SpecificLocation: data?.SpecificLocation ? data?.SpecificLocation : "",
                Latitude_Longitude: (data?.Latitude && data?.Longitude) ? `${data?.Latitude},${data?.Longitude}` : undefined,
                // Longitude: checkRes(data?.Longitude),
                SubDepartmentId: checkRes(data?.SubDepartment?.id),
                department: checkRes(data?.SubDepartment?.Department?.id),
                IncidentTypeId: checkRes(data?.IncidentTypeId),
                ClassificationId: checkRes(data?.ClassificationId),
                RulesBroken: checkRes(data?.RulesBroken),
                NatureOfIncident: checkRes(data?.NatureOfIncident),
                Temperature: checkRes(data?.Temperature)?.toString(),
                Visibility: checkRes(data?.Visibility),
                TimeOfDay: checkRes(data?.TimeOfDay),
                DrugAlcoholTest: checkRes(data?.DrugAlcoholTest),
                PicturesTaken: checkRes(data?.PicturesTaken),
                ApproverSummary: checkRes(data?.ApproverSummary),
                RuleViolation: checkRes(data?.RuleViolation),
                Injury: checkRes(data?.Injury),
                HumanFailure: checkRes(data?.HumanFailure),
                FatigueAFactor: checkRes(data?.FatigueAFactor),
                RailIncident: checkRes(data?.RailIncident),
                SupervisorNotified: checkRes(data?.SupervisorNotified),
                createdBy: `${checkRes(data?.EnteredBy?.firstName)}${data?.EnteredBy?.firstName ? data?.EnteredBy?.lastName : ""}`,
                RailIncidentData:
                {
                    ApparentCause: checkRes(data?.RailIncidents[0]?.ApparentCause),
                    CrewActivityAtIncident: checkRes(data?.RailIncidents[0]?.CrewActivityAtIncident),
                    CrewLocationAtIncident: checkRes(data?.RailIncidents[0]?.CrewLocationAtIncident),
                    Empties: checkRes(data?.RailIncidents[0]?.Empties),
                    HAZMATCarsDerailOrDamaged: checkRes(data?.RailIncidents[0]?.HAZMATCarsDerailOrDamaged),
                    HAZMATCarsReleasedOrSpilled: checkRes(data?.RailIncidents[0]?.HAZMATCarsReleasedOrSpilled),
                    HoursOnDuty: checkRes(data?.RailIncidents[0]?.HoursOnDuty)?.toString(),
                    IncidentId: checkRes(data?.RailIncidents[0]?.IncidentId),
                    JobId: checkRes(data?.RailIncidents[0]?.JobId),
                    Loads: checkRes(data?.RailIncidents[0]?.Loads),
                    RailcarEquipNums: checkRes(data?.RailIncidents[0]?.RailcarEquipNums),
                    TotalHAZMATCars: checkRes(data?.RailIncidents[0]?.TotalHAZMATCars),
                    approxSpeed: checkRes(data?.RailIncidents[0]?.approxSpeed)?.toString(),
                    employeesNotified: checkRes(data?.RailIncidents[0]?.employeesNotified),
                    locomotiveNum: checkRes(data?.RailIncidents[0]?.locomotiveNum),
                    moveType: checkRes(data?.RailIncidents[0]?.moveType),
                    notifiedDate: checkDate(data?.RailIncidents[0]?.notifiedDate, "date"),
                    notifiedTime: checkDate(data?.RailIncidents[0]?.notifiedTime, "time"),
                    rerailMethod: checkRes(data?.RailIncidents[0]?.rerailMethod),
                    totalCars: checkRes(data?.RailIncidents[0]?.totalCars),
                    travelDirection: checkRes(data?.RailIncidents[0]?.travelDirection),
                    rerailingCrewName: checkRes(data?.RailIncidents[0]?.rerailingCrewName),
                    timeArrived: checkDate(data?.RailIncidents[0]?.timeArrived, "time"),
                    timeCalled: checkDate(data?.RailIncidents[0]?.timeCalled, "time"),
                    timeReleased: checkDate(data?.RailIncidents[0]?.timeReleased, "time"),
                },
                InvolvedEmployee: data?.InvolvedEmployees?.length && data?.InvolvedEmployees?.map(x => {
                    let [empById] = employeeList?.filter(e => e?.id == x?.EmployeeId)
                    if (moment(empById?.hiredDate).isValid()) {
                        return { EmployeeId: checkRes(x?.EmployeeId), Hired6Months: moment(empById?.hiredDate).format("MM-DD-YYYY"), Notes: checkRes(x?.Notes), Position: checkRes(x?.Position) }
                    } else {
                        return { EmployeeId: checkRes(x?.EmployeeId), Hired6Months: "Not Available", Notes: checkRes(x?.Notes), Position: checkRes(x?.Position) }
                    }
                }),
                TotalCost: checkRes(data?.TotalCost)?.toString(),
                Reportable_Recordable: checkRes(data?.Reportable_Recordable),
                FRA_OSHA: checkRes(data?.FRA_OSHA),
                CauseCode: checkRes(data?.CauseCode),
                CauseType: checkRes(data?.CauseType),
                ApprovedDate: checkDate(data?.ApprovedDate, "date"),
                CorrectiveActions: checkRes(data?.CorrectiveActions),
                // ApproverSummary: checkRes(data?.ApproverSummary)
            })
            formFinalize?.setFieldsValue({
                TotalCost: checkRes(data?.TotalCost)?.toString(),
                Reportable_Recordable: checkRes(data?.Reportable_Recordable),
                FRA_OSHA: checkRes(data?.FRA_OSHA),
                CauseCode: checkRes(data?.CauseCode),
                CauseType: checkRes(data?.CauseType),
                ApprovedDate: checkDate(data?.ApprovedDate, "date"),
                CorrectiveActions: checkRes(data?.CorrectiveActions),
            })
            setEmpty(true)
            utility?.dispatch(setPageLoader({ pageName: "main", flag: false }))
        }, 500);
    }

    useEffect(() => {
        if (id) fetchIncidentByID(id)
        else fetchData()
    }, [])

    const Keys = {
        layerOne: ["DrugAlcoholTest", "PicturesTaken", "Injury", "HumanFailure", "FatigueAFactor", "RuleViolation", "SupervisorNotified", "RailIncident"],
        layerTwo: ["notifiedTime", "timeCalled", "timeArrived", "timeReleased"],

    }

    const removeFile = (fileIndexToOptOut) => {
        const files = Array.from(additionalFiles).filter(
            (files, fileIndex) => fileIndex !== fileIndexToOptOut
        );

        setAdditionalFiles(files);
    };

    const attatchmentFilesdata = {
        additionalFiles,
        setAdditionalFiles,
        removeFile,
        uploadedFiles,
        isFinalized
    };

    const onFinish = async (values) => {



        Object.entries(values).forEach(([key, value]) => {
            if (Keys?.layerOne?.includes(key)) {
                if (!value) {
                    values[key] = false
                }
            }
            if (!Keys?.layerOne?.includes(key))
                if ([undefined].includes(value)) values[`${key}`] = null
            if (key === "IncidentTime") {

                if (value) values[key] = moment(value).format("HH:mm")
            }
            if (key === "Latitude_Longitude") {
                if ([undefined].includes(value)) {
                    values["Latitude"] = null
                    values["Longitude"] = null
                }
                else {
                    const splittedValues = value?.split(",")
                    values["Latitude"] = splittedValues[0]
                    values["Longitude"] = splittedValues[1]
                }
            }
        })


        if (values?.RailIncident && values?.RailIncidentData) {
            Object.entries(values?.RailIncidentData).forEach(([key, value]) => {
                if (["employeesNotified"].includes(key)) {
                    if (!value) {
                        values["RailIncidentData"][key] = false
                    }
                }
                if (!["employeesNotified"].includes(key))
                    if ([undefined].includes(value)) values["RailIncidentData"][`${key}`] = null

                if (Keys?.layerTwo?.includes(key)) {
                    if (value) values["RailIncidentData"][key] = moment(value).format("HH:mm")
                }
            })
        } else {
            values["RailIncidentData"] = {}
        }


        values?.InvolvedEmployee?.length > 0 ? values?.InvolvedEmployee?.map((x, i) =>
            Object.entries(x)?.forEach(([key, value]) => {
                if (key === "Hired6Months") {
                    delete values["InvolvedEmployee"][i][key]
                }
                if (key !== "Hired6Months")
                    if ([undefined].includes(value)) values["InvolvedEmployee"][i][key] = null

            })
        ) : values["InvolvedEmployee"] = []

        if (id) {
            let res = await hr?.incidentUpdate({ id, values })
            if (res?.httpStatus === 200) {
                message.success('Sucessfully Updated'); // Display success message

                history.push({
                    pathname: "/safety-testing",
                    state: { activeTab: 2 }
                }, { fromIncident: true });
                // history.push("/safety-testing", { fromIncident: true })

            }
        }
        else {
            let res = await hr?.createIncident(values)
            if (res?.httpStatus === 200) {
                message.success('Sucessfully Updated'); // Display success message

                history.push({
                    pathname: "/safety-testing",
                    state: { activeTab: 2 }
                }, { fromIncident: true });
            }
            else {
                message.error('Error')
            }
        }

    }

    const getLocation = async () => {
        setLocLoading(true)

        function success(position) {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            setlocation({ latitude, longitude })
            form.setFieldsValue({
                Latitude_Longitude: `${latitude},${longitude}`,
            })
        }

        function error(error) {
            return message.error(
                `Unable to retrieve your location: Kindly Enter Lat Long `
            );
        }

        if (!navigator.geolocation) {

        } else {
            navigator.geolocation.getCurrentPosition(success, error);
        }
        setLocLoading(false)

    }


    const causeCodeOptinsInFormat = causeCodeOptions?.map(x => { return { id: x?.id, title: `${x?.Code}${x?.Description ? `-${x?.Description}` : ""}`, code: x?.Code } })


    let fields = {
        general: [
            { isRequired: true, isDisabled: isFinalized, type: 2, label: "Incident Date", keyName: 'IncidentDate' },
            { isRequired: true, isDisabled: isFinalized, type: 4, label: "Incident Time", keyName: 'IncidentTime' },
            { isRequired: true, isDisabled: true, type: id ? 1 : 9, label: "Created By", keyName: 'createdBy' },

        ],
        location: [
            { isRequired: true, isDisabled: isFinalized, type: 3, label: "TGS Location", options: locations || [], keyName: "LocationId", placeholder: "TGS Location" },
            { isRequired: true, isDisabled: isFinalized, type: 1, label: "Specific Location", keyName: 'SpecificLocation', placeholder: "Specific Location", validation: "" },
            { isRequired: false, isDisabled: isFinalized, type: 1, label: "Latitude , Longitude", keyName: 'Latitude_Longitude', placeholder: "Latitude , Longitude", validation: /^[0-9\-.,]+$/g },
            // {  isRequired: true,isDisabled: isFinalized, type: 1, label: "Longitude", keyName: 'Longitude', placeholder: "Longitude", validation: /^[0-9.,]+$/g },
            { type: isFinalized ? 9 : 8, label: "Get", onClick: () => getLocation() }
        ],
        generalInfo: [
            { isRequired: true, isDisabled: isFinalized, type: 3, label: "Department", options: departments || [], keyName: "department", onChange: (value) => fetchSubDepartments(value), placeholder: "Department" },
            { isRequired: true, isDisabled: isFinalized, type: 3, label: "Sub Department", options: subDepartment || [], keyName: "SubDepartmentId", placeholder: "Sub Department" },
            { isRequired: true, isDisabled: isFinalized, type: 3, label: "Incident Type", options: types, keyName: "IncidentTypeId", placeholder: "Incident Type", onChange: (value) => fetchClassifications(value) },
            { isDisabled: isFinalized, type: 3, label: "Classification", options: classification, keyName: "ClassificationId", placeholder: "Classification" },
            { isDisabled: isFinalized, type: 1, label: "Rules Broken", keyName: 'RulesBroken', validation: /^[0-9.,]+$/g, placeholder: "Rules Broken" },
            { isDisabled: isFinalized, type: 1, label: "Nature Of Incident", keyName: 'NatureOfIncident', placeholder: "Nature Of Incident" },
            { isDisabled: isFinalized, type: 6, label: "Temperature (Degrees)", keyName: 'Temperature', placeholder: "Temperature" },
            { isDisabled: isFinalized, type: 3, label: "Visibility", key: 'title', options: visibiltyIncident, keyName: "Visibility", placeholder: "Visibility" },
            { isDisabled: isFinalized, type: 3, label: "T.O.D", key: 'title', options: TODIncident, keyName: "TimeOfDay", placeholder: "T.O.D" },
            { isDisabled: isFinalized, type: 5, label: "Incident Summary", keyName: 'ApproverSummary', rows: 6 },

            { isDisabled: isFinalized, type: 7, label: "Sent for Drug/Alcohol", keyName: "DrugAlcoholTest", },
            { isDisabled: isFinalized, type: 7, label: "Pictures Taken ?", keyName: "PicturesTaken", },
            { isDisabled: isFinalized, type: 7, label: "Injury", keyName: "Injury", },
            { isDisabled: isFinalized, type: 7, label: "Human Failure ?", keyName: "HumanFailure", },
            { isDisabled: isFinalized, type: 7, label: "Fatigue a Factor ?", keyName: "FatigueAFactor", },
            { isDisabled: isFinalized, type: 7, label: "Rule Violation", keyName: "RuleViolation", },
            { isDisabled: isFinalized, type: 7, label: "Supervisor Notified ?", keyName: "SupervisorNotified", },
            { isDisabled: isFinalized, type: 7, label: "Rail Incident", keyName: "RailIncident", onChange: (value) => setRailIncident(value) },
        ],
        railRoad: {
            general: [
                { isDisabled: isFinalized, type: 1, placeholder: "Job ID", label: "Job ID", keyName: ["RailIncidentData", 'JobId'] },
                { isDisabled: isFinalized, type: 1, placeholder: "Total Cars", label: "Total Cars", keyName: ["RailIncidentData", 'totalCars'] },
                { isDisabled: isFinalized, type: 1, placeholder: "Loads", label: "Loads", keyName: ["RailIncidentData", 'Loads'] },
                { isDisabled: isFinalized, type: 1, placeholder: "Empties", label: "Empties", keyName: ["RailIncidentData", 'Empties'] },
                { isDisabled: isFinalized, type: 1, placeholder: "Total HAZMAT Cars", label: "Total HAZMAT Cars", keyName: ["RailIncidentData", 'TotalHAZMATCars'] },
                { isDisabled: isFinalized, type: 1, placeholder: "HAZMAT Cars Derailed/Damaged", label: "HAZMAT Cars Derailed/Damaged", keyName: ["RailIncidentData", 'HAZMATCarsDerailOrDamaged'] },
                { isDisabled: isFinalized, type: 1, placeholder: "HAZMAT Cars Released/Spilled", label: "HAZMAT Cars Released/Spilled", keyName: ["RailIncidentData", 'HAZMATCarsReleasedOrSpilled'] },
                { isDisabled: isFinalized, type: 1, placeholder: "Locomotive Nbrs", label: "Locomotive Nbrs", keyName: ["RailIncidentData", 'locomotiveNum'] },
                { isDisabled: isFinalized, type: 1, placeholder: "Railcar Equip Nbrs", label: "Railcar Equip Nbrs", keyName: ["RailIncidentData", 'RailcarEquipNums'] },
                { isDisabled: isFinalized, type: 3, label: "Safety Employee Notified", keyName: ["RailIncidentData", "employeesNotified"], options: employees || [] },
                { isDisabled: isFinalized, type: 2, label: "Notified Date", keyName: ["RailIncidentData", 'notifiedDate'], },
                { isDisabled: isFinalized, type: 4, label: "Notified Time", keyName: ["RailIncidentData", 'notifiedTime'], },
                { isDisabled: isFinalized, type: 5, label: "Apparent Cause", keyName: ["RailIncidentData", 'ApparentCause'], placeholder: "Apparent Cause" },
                { isDisabled: isFinalized, type: 3, label: "Cause Code", key: 'code', options: causeCodeOptinsInFormat, keyName: "CauseCode", width: "500px" },
            ],
            movement: [
                { isDisabled: isFinalized, type: 6, label: "Approximate Speed (MPH)", keyName: ["RailIncidentData", 'approxSpeed'], placeholder: "Approximate Speed (MPH)" },
                { isDisabled: isFinalized, type: 3, label: "Direction Of Travel", key: 'title', options: IncidentDropdowns?.DirectionOfTravel, keyName: ["RailIncidentData", "travelDirection"] },
                { isDisabled: isFinalized, type: 3, label: "Move Type", key: 'title', options: IncidentDropdowns?.MoveTypes, keyName: ["RailIncidentData", "moveType"] },
            ],
            crew: [
                { isDisabled: isFinalized, type: 6, label: "Hours On Duty", keyName: ["RailIncidentData", 'HoursOnDuty'] },
                { isDisabled: isFinalized, type: 1, label: "Crew Location at time of Incident", keyName: ["RailIncidentData", 'CrewLocationAtIncident'] },
                { isDisabled: isFinalized, type: 1, label: "What was taking place ?", keyName: ["RailIncidentData", 'CrewActivityAtIncident'] },
            ],
            rerail: [
                { isDisabled: isFinalized, type: 1, label: "Re-railing Crew Name", keyName: ["RailIncidentData", 'rerailingCrewName'] },
                { isDisabled: isFinalized, type: 4, label: "Time Called", keyName: ["RailIncidentData", 'timeCalled'], },
                { isDisabled: isFinalized, type: 4, label: "Time Arrive", keyName: ["RailIncidentData", 'timeArrived'], },
                { isDisabled: isFinalized, type: 4, label: "Released", keyName: ["RailIncidentData", 'timeReleased'], },
                { isDisabled: isFinalized, type: 5, label: "Re-Rail Method", keyName: ["RailIncidentData", 'rerailMethod'] },
            ]
        },
        approver: [
            // { type: 3, label: "Open/Close", key: 'title', options: IncidentDropdowns?.OpenClosed, keyName: "Open_Closed" },
            { isDisabled: isFinalized, type: 6, label: "Total Cost", keyName: 'TotalCost' },
            { isDisabled: isFinalized, type: 3, label: "Reportable/Recordable", key: 'title', options: IncidentDropdowns?.REPORTABLE_RECORDABLE, keyName: "Reportable_Recordable" },
            { isDisabled: isFinalized, type: 3, label: "FRA/OSHA", key: 'title', options: IncidentDropdowns?.FRA_OSHA, keyName: "FRA_OSHA" },
            { isDisabled: isFinalized, type: 3, label: "Cause Type", key: 'title', options: IncidentDropdowns?.CauseTypes, keyName: "CauseType" },
            // {  isDisabled: isFinalized,type: 1, label: "Approved By", keyName: 'totalCost },
            { isDisabled: isFinalized, type: 2, label: "Approaved Date", keyName: 'ApprovedDate' },
            { isDisabled: isFinalized, type: 5, label: "Corrective Actions", keyName: 'CorrectiveActions' },
        ],

    }

    const onFinalizeIncidentFinish = async (values) => {

        Object.entries(values).forEach(([key, value]) => {
            if (!values[key]) values[key] = null
        })
        setIsModalOpen(false)
        let res = await hr?.finalizeIncident({ id, values })
        if (res?.httpStatus === 200) return await fetchIncidentByID(id)
        setIsModalOpen(true)
    }

    const LabelAntd = ({ text }) => {
        return <Grid xs={12} className={`mbold`} style={{ marginBottom: '10px', fontWeight: '800' }}>{text}</Grid>
    }

    const onClickReOpen = async () => {
        setIsReopenModalOpen(false)
        let res = await hr?.reopenIncident(id)
        if (res?.httpStatus === 200) {
            await fetchIncidentByID(id)
            return
        }
    }


    const filterOption = (input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase());


    return (
        <PageLayout>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Incident</Grid>
                <GoBack path={"/safety-testing"} state={{ activeKey: 3 }} />
                <Form onFinish={onFinish} onFinishFailed={(err) => { }} form={form}
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center',
                    }} >

                    <div className="d-flex-column" style={{ marginTop: "20px" }}>
                        <div className="d-flex-colum">
                            <h3 style={{ color: "#2863AD", fontWeight: "bold", marginTop: "20px" }}>{id ? "Edit" : "Enter New"} Incident</h3>
                            <div className="incident-form">
                                {empty && <> <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                    <DynamicFormFieldsAntd fields={fields?.general} form={form} />

                                </div>
                                    <LabelIncident text={"Location Of Incident"} />
                                    <Spin spinning={LocLoading || false}>
                                        <div style={{ display: "grid", gridTemplateColumns: "30% 30% 20% 10%", gap: "15px" }}>
                                            <DynamicFormFieldsAntd fields={fields?.location} form={form} />
                                        </div>
                                    </Spin>
                                    <LabelIncident text={"General Information"} />
                                    <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                        <DynamicFormFieldsAntd fields={fields?.generalInfo.slice(0, 9)} form={form} />
                                    </div>
                                    <div style={{ display: "grid", gridTemplateColumns: "93%", gap: "15px" }}>
                                        <DynamicFormFieldsAntd fields={fields?.generalInfo.slice(9, 10)} form={form} />
                                    </div>
                                    <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                        <DynamicFormFieldsAntd fields={fields?.generalInfo.slice(10)} form={form} />
                                    </div>

                                    {/* <AttachFilesIncident data={attatchmentFilesdata} /> */}

                                    <LabelIncident text={"Employees Involved"} />
                                    <Form.List name={"InvolvedEmployee"}>
                                        {(fields, { add, remove }) => (
                                            <>
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                                                    {!isFinalized && <Form.Item>
                                                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                                            Add Employee Involved
                                                        </Button>
                                                    </Form.Item>}
                                                </div>
                                                {fields.map(({ key, name, ...restField }, i) => (
                                                    <div style={{ display: "grid", gridTemplateColumns: "20% 20% 15% 25% 10%", gap: "15px", }}>
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <LabelAntd text={"Name"} />
                                                            <Form.Item
                                                                name={[name, 'EmployeeId']}
                                                                rules={[{ required: true, message: "Please select any Employee" }]}
                                                            >
                                                                <Select
                                                                    placeholder={"Name"}
                                                                    optionFilterProp="children"
                                                                    showSearch
                                                                    filterOption={filterOption}
                                                                    disabled={isFinalized}
                                                                    onChange={(value, obj) => {
                                                                        let [empById] = employees?.filter(e => e?.id === value)
                                                                        if (moment(empById?.hiredDate).isValid()) {
                                                                            form.setFieldValue(
                                                                                ["InvolvedEmployee", i, "Hired6Months"],
                                                                                moment(empById?.hiredDate).format("MM-DD-YYYY")
                                                                            )
                                                                        } else {
                                                                            form.setFieldValue(
                                                                                ["InvolvedEmployee", i, "Hired6Months"],
                                                                                "Not Available"
                                                                            )
                                                                        }
                                                                    }}
                                                                >
                                                                    {employees?.map(x =>
                                                                        <Select.Option value={x?.id}>{x?.title}</Select.Option>
                                                                    )}
                                                                </Select>
                                                            </Form.Item>
                                                        </div >
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <LabelAntd text={"Position"} />
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'Position']}
                                                            >
                                                                <Input placeholder="Position" disabled={isFinalized} style={inputStyle} />
                                                            </Form.Item>
                                                        </div >
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <LabelAntd text={"Hired Date"} />

                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'Hired6Months']}
                                                            >
                                                                {/* <Switch checked={id ? form?.getFieldValue([name, i, "Hired6Months"]) : undefined} disabled={isFinalized} /> */}
                                                                <Input placeholder="Hired Date" disabled={true} style={{ padding: "15px", borderRadius: "8px" }} />
                                                            </Form.Item>
                                                        </div >
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <LabelAntd text={"Notes"} />
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'Notes']}
                                                            >
                                                                <TextArea placeholder={"Notes"} disabled={isFinalized} style={inputStyle} />
                                                            </Form.Item>
                                                        </div>


                                                        {!isFinalized && <Cancel onClick={() => remove(name)} style={{ marginBottom: "24px", cursor: "pointer" }} />}
                                                    </div>
                                                ))}

                                            </>
                                        )}
                                    </Form.List>

                                    {RailIncident && <div style={{ margin: "30px 0" }}>
                                        <h3 style={{ color: "#2863AD", fontWeight: "bold" }}>Rail Incident Data</h3>
                                        <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                            <DynamicFormFieldsAntd form={form} fields={fields?.railRoad.general} />
                                        </div>
                                        <LabelIncident text={"Movement Information"} />
                                        <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                            <DynamicFormFieldsAntd form={form} fields={fields?.railRoad.movement} />
                                        </div>
                                        <LabelIncident text={"Crew Information"} />
                                        <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                            <DynamicFormFieldsAntd form={form} fields={fields?.railRoad.crew} />
                                        </div>
                                        <LabelIncident text={"Re-Railing Information"} />
                                        <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                            <DynamicFormFieldsAntd form={form} fields={fields?.railRoad.rerail} />
                                        </div>
                                    </div>}

                                    {isFinalized ? <>
                                        <div style={{ color: "#2863AD", fontWeight: "bold", margin: "20px 0" }}>Approaver Information</div>
                                        <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                                            <DynamicFormFieldsAntd form={form} fields={fields?.approver} />
                                        </div>
                                    </> : <></>}
                                </>}
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "50px", alignItems: "center", gap: "20px" }}>
                        {isFinalized ?
                            <span
                                onClick={() => setIsReopenModalOpen(true)}
                                style={{ background: "#2963AD", color: "white", borderRadius: "10px", padding: "10px 20px", border: "none", cursor: "pointer" }}>Reopen Incident</span> :
                            <>
                                <button
                                    style={{ background: "#2963AD", color: "white", borderRadius: "10px", padding: "10px 20px", border: "none", cursor: "pointer" }}
                                    type="submit">{id ? "Update" : "Save"}
                                </button>
                                {id ?
                                    <span onClick={() => setIsModalOpen(true)}
                                        style={{ background: "#2963AD", color: "white", borderRadius: "10px", padding: "10px 20px", border: "none", cursor: "pointer" }}>
                                        Finalize Incident
                                    </span>
                                    : <></>}
                            </>
                        }
                    </div>

                </Form>
            </Grid>
            {/* Finalize Incident Modal */}
            <Modal
                title="Finalize Incident"
                width={"65%"} open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={false}
                style={{
                    top: 20,
                }}
            >
                <Form onFinish={onFinalizeIncidentFinish} onFinishFailed={(err) => { }} className="incident-form" form={formFinalize}>
                    {empty ?
                        <div style={{ display: "grid", gridTemplateColumns: "30% 30% 30%", gap: "15px" }}>
                            <DynamicFormFieldsAntd form={formFinalize} fields={fields?.approver} />
                        </div> : <></>}
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "30px", alignItems: "center", gap: "20px" }}>
                        <button style={{ background: "#2963AD", color: "white", borderRadius: "10px", width: "120px", height: "40px", cursor: "pointer", border: "none" }}
                            type="submit">{"Finalize"}</button>
                    </div>
                </Form>
            </Modal>
            {/* Reopen Incident Modal */}
            <Modal
                // title="Reopen Incident"
                closeIcon={<></>}
                style={{
                    top: 20,
                }}
                width={"50%"}
                open={isReopenModalOpen}
                onOk={() => setIsReopenModalOpen(false)}
                onCancel={() => setIsReopenModalOpen(false)}
                footer={false}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "15px", justifyContent: "center", flexDirection: "column" }}>
                    <span style={{ fontSize: "15px" }}>Are you sure you want to reopen this incident ?</span>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "", alignItems: "center", gap: "20px" }}>
                        <span
                            onClick={onClickReOpen}
                            style={{ background: "#2963AD", color: "white", borderRadius: "10px", padding: "5px 15px", border: "none", cursor: "pointer" }} >{"Yes"}</span>
                        <span
                            onClick={() => setIsReopenModalOpen(false)}
                            style={{ background: "#2963AD", color: "white", borderRadius: "10px", border: "none", padding: "5px 15px", cursor: "pointer" }} >{"No"}</span>
                    </div>
                </div>

            </Modal>
        </PageLayout>
    )
}

export default EnterIncidentAntd